module.exports = __webpack_public_path__ + "img/nav-logout.48858e52.svg";